import * as _ from 'underscore';

import { DataPoint } from '@tableau/metrics-shared-widgets-dom';
import { ConnectedViewContextType } from '../ServerApi/types/IMetric';
import { IMetricDataPointsSchema } from '../ServerApi/types/IMetricDataList';
import { IMetricUsageInfo } from '../ServerApi/types/IUsageInfo';
import { ICreatedItemInfo, IDescriptionItemInfo, IExplorableItemTypeInfo, IFavoriteItem, IIdItemInfo, INamedItemInfo, IOwnedItemInfo, IProjectItemInfo, ISuspendedItem, ITaggedItemInfo, IUpdatedItemInfo } from './resourceInfoParts';

export interface IMetricInfo extends
    IExplorableItemTypeInfo<'metric'>,
    INamedItemInfo,
    IIdItemInfo,
    IUpdatedItemInfo,
    ICreatedItemInfo,
    IFavoriteItem,
    IDescriptionItemInfo,
    ITaggedItemInfo,
    IProjectItemInfo,
    IMetricDataInfo,
    IOwnedItemInfo,
    Partial<ISuspendedItem>
{
  connectedView: IConnectedViewInfo;
  usageInfo?: IMetricUsageInfo;
  usageInfoMaxValues?: IMetricUsageInfo;
}

export type IMetricInfoWithoutData = Omit<IMetricInfo, keyof IMetricDataInfo>;

export interface IMetricDataInfo {
  dataPoints?: ReadonlyArray<DataPoint>;
  schema?: IMetricDataPointsSchema;
  dataRefreshedTimestamp?: string;
}

export interface IConnectedViewInfo extends INamedItemInfo {
  viewId: string;
  isViewModified: boolean;
  path: string;
  thumbnailUrl: string;
  type: ConnectedViewContextType;
}

export function isMetricInfo(metric: IExplorableItemTypeInfo): metric is IMetricInfo {
  return (metric.contentType === 'metric');
}
